// https://ec.europa.eu/eurostat/statistics-explained/index.php?title=Glossary:Country_codes
export const CountryCodes = [
  // European Union (EU)
  'BE',
  'BG',
  'CZ',
  'DK',
  'DE',
  'EE',
  'IE',
  'EL',
  'ES',
  'FR',
  'HR',
  'IT',
  'CY',
  'LV',
  'LT',
  'LU',
  'HU',
  'MT',
  'NL',
  'AT',
  'PL',
  'PT',
  'RO',
  'SI',
  'SK',
  'FI',
  'SE',
  // European Free Trade Association (EFTA)
  'IS',
  'LI',
  'NO',
  'CH',
  // Extra
  'UK',
  'US',
]

export const emailPlaceholder = 'contact@company.com'
export const websitePlaceholder = 'https://company.com'
export const telephonePlaceholder = '+32 123 12 12 12'

export const oneHourInMs = 3600000
export const oneDayInMs = oneHourInMs * 24
export const oneMonthInMs = oneDayInMs * 30
export const oneYearInMs = oneDayInMs * 365
